import { clsx, type ClassValue } from 'clsx';
import moment from 'moment';
import { twMerge } from 'tailwind-merge';

export function cn(...args: ClassValue[]) {
  return twMerge(clsx(args));
}

export function trimNonWordChars(inputString: string): string {
  // Use regular expression to match non-word characters at the beginning of the string
  const match = inputString.match(/^\W*/);

  // If there is a match, remove the matched non-word characters
  const trimmedString: string = match
    ? inputString.slice(match[0].length)
    : inputString;

  return trimmedString;
}

export function secondsToHumanReadableTime(secondsDuration: any): string {
  const duration = moment.duration(secondsDuration, 'seconds');
  const hours = duration.hours();
  const minutes = duration.minutes();
  const seconds = duration.seconds();
  const hoursPart = hours < 10 ? `0${hours}` : hours;
  const minutesPart = minutes < 10 ? `0${minutes}` : minutes;
  const secondsPart = seconds < 10 ? `0${seconds}` : seconds;
  return `${hoursPart}:${minutesPart}:${secondsPart}`;
}
